export default "__VITE_ASSET__DEwSvBzL__"